export const idPlnMomentaMais = 158427
export const idPresentationDAEM = 636643
export const idPresentationEZONIA = 555638
export const idPresentationRIPOSO = 536240

export const idCupomDAEM = '63664'
export const idCupomEZONIA = '81821'
export const idCupomRIPOSO = '91221'
